import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getFieldList as getFieldListApi,
	getField as getFieldApi,
	addNewField as addNewFieldApi,
	updateField as updateFieldApi,
	deleteField as deleteFieldApi,
} from '../../helpers/screen/backend_helper';

export const getFieldList = createAsyncThunk('field/getFieldList', async () => {
	try {
		const response = getFieldListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getField = createAsyncThunk('field/getField', async field_id => {
	try {
		const response = getFieldApi(field_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewField = createAsyncThunk(
	'field/addNewField',
	async field => {
		try {
			const response = addNewFieldApi(field);
			toast.success('Field agregado exitosamente.', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al agregar field.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateField = createAsyncThunk(
	'field/updateField',
	async field => {
		try {
			const response = updateFieldApi(field);
			toast.success('Field actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar field.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteField = createAsyncThunk(
	'field/deleteField',
	async field => {
		try {
			const response = await deleteFieldApi(field);
			toast.success('Field eliminado exitosamente.', { autoClose: 3000 });
			return { field, ...response };
		} catch (error) {
			toast.error('Error al eliminar field.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);
